'use client';

import { useState } from 'react';

export const useGoogleLogin = () => {
  const [error, setError] = useState<string>('');

  const handleGoogleLogin = async () => {
    try {
      setError('');
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/auth/google/oauth-url?mode=login`
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Google認証URLの取得に失敗しました');
      }

      const data = await response.json();

      if (data.error) {
        throw new Error(data.error);
      }

      window.location.href = data.url;
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Googleログインに失敗しました');
    }
  };

  return { handleGoogleLogin, error };
};
